import { Heart } from "lucide-react";
import type { CurrentMatch } from "../../types";

export type MatchNavIconState = "none" | "pending" | "connected";

export function getMatchNavIconState(match?: CurrentMatch | null): MatchNavIconState {
  if (!match) return "none";
  if (match.status === "connected") return "connected";
  if (match.showRejectionMessage) return "none";
  return "pending";
}

export function MatchNavIcon({ state, size = 22 }: { state: MatchNavIconState; size?: number }) {
  if (state === "connected") {
    return <Heart size={size} fill="currentColor" strokeWidth={2} />;
  }

  if (state === "pending") {
    return (
      <span className="match-nav-icon match-nav-icon--half" aria-hidden="true">
        <Heart size={size} strokeWidth={2} />
      </span>
    );
  }

  return <Heart size={size} strokeWidth={2} />;
}
